import Loading from 'components/loading'
import React, { useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { headerAgencyGroupTable } from './header'

import IconDelete from 'assets/images/icon-delete.svg'
import IconDot from 'assets/images/icon-dot.svg'
// import IconInformation from 'assets/images/icon-information.svg'

import { useMutation } from '@apollo/client'
import { useOutsideClick } from 'components/hooks/useOutsideClick'
import SingleRowActionBase from 'components/partials/singleRowActionBase'
import { notify } from 'components/toastify'
import { STATUS } from 'constants/messages'
import { IAgencyGroup } from 'pages/agency-group-management/interface'
import { DELETE_AGENCY_GROUP } from 'queries/admin/agencyGroup'
import { useSession } from 'helpers/checkSession'

interface Props {
  tableData: IAgencyGroup[]
  hasMoreData: boolean
  isLoading: boolean
  handleRefetch: () => void
  handleFetchMore: () => void
}

const AgencyGroupTable: React.FC<Props> = ({
  tableData,
  hasMoreData,
  isLoading,
  handleRefetch,
  handleFetchMore,
}) => {
  const { handleErrorSession } = useSession()
  const [currentRowSelected, setCurrentRowSelected] = useState<IAgencyGroup>()
  const [isShowAction, setIsShowAction] = useState<boolean>(false)

  const [deleteAgencyGroup] = useMutation(DELETE_AGENCY_GROUP, {
    variables: {
      agencyGroupId: currentRowSelected?.agencyGroupId ?? 0,
    },
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data.deleteAgencyGroup) {
        notify('Delete successfully!', STATUS.SUCCESS)
        handleRefetch()
      } else {
        notify('Something wrong', STATUS.ERROR)
      }
    },
    onError: (error) => {
      if (error.message) {
        handleErrorSession(error, error.message)
      } else {
        notify('Something wrong', STATUS.ERROR)
      }
    },
  })

  const ref = useOutsideClick(() => {
    setIsShowAction(false)
  })

  const onHandleClickShowAction = (rowItem: IAgencyGroup) => {
    if (currentRowSelected?.agencyGroupId === rowItem.agencyGroupId) {
      setIsShowAction(!isShowAction)
    } else {
      setIsShowAction(true)
    }
    setCurrentRowSelected(rowItem)
  }

  const onClickDeleteAction = async (agencyGroupId: number) => {
    if (currentRowSelected) {
      await deleteAgencyGroup({
        variables: {
          agencyGroupId,
        },
      })
    }
  }

  return (
    <div>
      <table className="w-full text-left border-2 border-neutral-6 rounded-t-lg overflow-hidden">
        <thead className="bg-primary-shade4 text-body1 text-neutral-2 md:pr-4">
          <tr>
            {headerAgencyGroupTable.map((item: any, idx) => (
              <th key={idx} className={item.headerStyles}>
                <div className={`flex `}>
                  <span className={`${item.isOneLineRes && 'lg:mt-[-3.5px]'}`}>{item.name}</span>
                  <div className={`${item.isOneLineRes && 'lg:mt-[-3.5px]'}`}></div>
                </div>
              </th>
            ))}
          </tr>
        </thead>
      </table>

      {isLoading && <Loading className="relative py-6" height={30} width={30} />}

      {tableData.length === 0 && !isLoading ? (
        <p className="py-6 text-center text-body1 text-neutral-4">No data available.</p>
      ) : (
        <InfiniteScroll
          dataLength={tableData?.length}
          next={handleFetchMore}
          hasMore={hasMoreData}
          height={'max-content'}
          style={{ maxHeight: 300, minHeight: 200 }}
          loader={''}
          endMessage={''}
          className="cus-scrollbar"
        >
          {tableData?.map((data: IAgencyGroup, index: number) => (
            <table key={index} className="cursor-pointer w-full">
              <tbody>
                <tr className="h-[72px] w-full hover:bg-neutral-7 pt-5">
                  <td className={` ${headerAgencyGroupTable[0].rowWid}`}>
                    <div>
                      <span>{data.agencyGroupId}</span>
                    </div>
                  </td>
                  <td className={`${headerAgencyGroupTable[1].rowWid}`}>
                    <div>
                      <span>{data.agencyGroupName}</span>
                    </div>
                  </td>
                  <td className={`${headerAgencyGroupTable[2].rowWid}`}>
                    <button
                      className="min-w-[24px] mb-auto"
                      onClick={() => onHandleClickShowAction(data)}
                    >
                      <div className="relative">
                        <img src={IconDot} alt="Icon-Dot" />
                        {currentRowSelected?.agencyGroupId === data.agencyGroupId && isShowAction && (
                          <div
                            className={`absolute right-[2px] h-auto p-3 border shadow-2xl w-[220px] border-neutral-7 bg-neutral-8 rounded-xl z-10`}
                            ref={ref}
                          >
                            {/* <SingleRowActionBase
                                  handleAction={onClickDetailAction}
                                  icon={IconInformation}
                                  action="Detail"
                                  txt="Detail"
                                /> */}
                            <SingleRowActionBase
                              handleAction={() =>
                                onClickDeleteAction(currentRowSelected.agencyGroupId)
                              }
                              icon={IconDelete}
                              action="Delete"
                              txt="Delete"
                            />
                          </div>
                        )}
                      </div>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          ))}
        </InfiniteScroll>
      )}
    </div>
  )
}

export default AgencyGroupTable
